import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ConvertToString from "../../../components/Converter";
import { RowBody } from "../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../components/ToolTip";
import { selectModelFaktor } from "../../../store/slices/aeussereSlice";

export function Modelfactor({}) {
  const { t } = useTranslation("translation");

  const modelFaktor = useSelector(selectModelFaktor);

  return (
    <RowBody
      titleValue={<p>{t("aeussre.modelFactor")}</p>}
      indicesValue={
        <span>
          &eta;<sub>M</sub>
        </span>
      }
      inputValue={<span className="input">{ConvertToString(modelFaktor)}</span>}
      formulaValue={
        <ToolTip id={"modelFaktor"} type={IconType.INFO} text={t("aeussre.modelFaktorInfo")} />
      }
    />
  );
}
